import React from "react";
import { Skeleton } from "@material-ui/lab";
import { Box } from "@material-ui/core";
var Cards = function () { return (React.createElement(React.Fragment, null, Array.from({ length: 5 }).map(function (_, index) { return (React.createElement(Box, { mt: 1, key: index },
    React.createElement(Skeleton, { height: "150px", variant: "rect" }))); }))); };
export var PageSkeleton = function () { return (React.createElement(React.Fragment, null,
    React.createElement(Skeleton, { variant: "rect", height: 124 }),
    React.createElement(Box, { mt: 2 },
        React.createElement(Cards, null)))); };
